import React from 'react';

const STATUS_STYLES = {
  'Pending': 'bg-gray-100 text-gray-700',
  'In Progress': 'bg-blue-100 text-blue-700',
  'Ready to Ship': 'bg-blue-100 text-blue-700',
  'CSV Generated': 'bg-blue-100 text-blue-700',
  'Sent to Lab': 'bg-yellow-100 text-yellow-700',
  'Lab Results Received': 'bg-green-100 text-green-700',
  'Completed': 'bg-green-500 text-white'
};

function StatusBadge({ status }) {
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[status] || 'bg-gray-100'}`}>
      {status}
    </span>
  );
}

export default StatusBadge;

